var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-67f1c98d-8279-4bc4-9595-5be409619e8c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60.4 61.2",
    style: {
      enableBackground: "new 0 0 60.4 61.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000083778694424408351640000010290545089075892097_);}\r\n\t.st2{fill:url(#SVGID_00000160898194392859807490000012360782269192892572_);}\r\n\t.st3{fill:url(#SVGID_00000054246003315120486550000013616690020233889723_);}\r\n\t.st4{fill:url(#SVGID_00000107584228430256985250000013413678281175139263_);}\r\n\t.st5{fill:url(#SVGID_00000155133838348889622390000015339705519478591662_);}\r\n\t.st6{fill:url(#SVGID_00000074428247330898424600000009052731240220016564_);}\r\n\t.st7{fill:url(#SVGID_00000020374292033903645110000003220855740866710939_);}\r\n\t.st8{fill:url(#SVGID_00000170245805399957178560000006531260877006172831_);}\r\n\t.st9{fill:url(#SVGID_00000123423798537418846540000003129842266097918367_);}\r\n\t.st10{fill:url(#SVGID_00000044890803422849598080000000586393656626250117_);}\r\n\t.st11{fill:url(#SVGID_00000175311366164564406250000005359479996564855479_);}\r\n\t.st12{fill:url(#SVGID_00000034793516545814449600000000793506165538307200_);}\r\n\t.st13{fill:url(#SVGID_00000031922249568600014080000008777526046166155428_);}\r\n\t.st14{fill:url(#SVGID_00000086667105593315779190000016808896104911241400_);}\r\n\t.st15{fill:url(#SVGID_00000168084086354367684010000008657830085629237637_);}\r\n\t.st16{fill:url(#SVGID_00000122695283735975966570000009009731174221131435_);}\r\n\t.st17{fill:url(#SVGID_00000137851495071335100980000008906686181816417466_);}\r\n\t.st18{fill:url(#SVGID_00000085948338622974265760000003514544986369141942_);}\r\n\t.st19{fill:url(#SVGID_00000072251098718814643670000010176819110229019298_);}\r\n\t.st20{fill:url(#SVGID_00000181087800944375694100000009601614009712389552_);}\r\n\t.st21{fill:url(#SVGID_00000016755401768029184120000007583959056792657580_);}\r\n\t.st22{fill:url(#SVGID_00000133492386939189495960000013601784371901573769_);}\r\n\t.st23{fill:url(#SVGID_00000098904944723173735220000015941768856462931374_);}\r\n\t.st24{fill:url(#SVGID_00000079463444795423462650000003532416869040250537_);}\r\n\t.st25{fill:url(#SVGID_00000016787040504095167080000008977597179408344475_);}\r\n\t.st26{fill:url(#SVGID_00000106854087452939685920000009802771359105282488_);}\r\n\t.st27{fill:url(#SVGID_00000150807961183068854820000015590033530808023711_);}\r\n\t.st28{fill:url(#SVGID_00000179608190453781676510000015641495224099664564_);}\r\n\t.st29{fill:url(#SVGID_00000039116526942748080110000006227439969556031147_);}\r\n\t.st30{fill:url(#SVGID_00000060740476051456404410000002311684171554760321_);}\r\n\t.st31{fill:url(#SVGID_00000021821279784330866930000018436972777549378476_);}\r\n\t.st32{fill:url(#SVGID_00000002349352718195795220000011133628524047962042_);}\r\n\t.st33{fill:url(#SVGID_00000125591232590562814420000005134010383300349610_);}\r\n\t.st34{fill:url(#SVGID_00000109710934212934329550000012846727743663835031_);}\r\n\t.st35{fill:url(#SVGID_00000064339836611017815500000004941336145543152284_);}\r\n\t.st36{fill:url(#SVGID_00000140735884156402376430000012368665423844058757_);}\r\n\t.st37{fill:url(#SVGID_00000021119101376600011680000004595284757137343420_);}\r\n\t.st38{fill:url(#SVGID_00000174574983697564028180000012183882879917503367_);}\r\n\t.st39{fill:url(#SVGID_00000107551558698239114180000003008498726644156066_);}\r\n\t.st40{fill:url(#SVGID_00000036964608668457240170000013354779953874816666_);}\r\n\t.st41{fill:url(#SVGID_00000054960607696350370680000001656160943061206931_);}\r\n\t.st42{fill:url(#SVGID_00000014607747757710538080000007166900026688294289_);}\r\n\t.st43{fill:url(#SVGID_00000112591366340082749190000006919156055484623005_);}\r\n\t.st44{fill:url(#SVGID_00000163771542606860701460000006026804784291860647_);}\r\n\t.st45{fill:url(#SVGID_00000093176077169197179430000005011144988203145383_);}\r\n\t.st46{fill:url(#SVGID_00000035533385350141461140000012368643898645546401_);}\r\n\t.st47{fill:url(#SVGID_00000062182405075683663340000009782654761196585661_);}\r\n\t.st48{fill:url(#SVGID_00000107560910801461155860000013758703287812437431_);}\r\n\t.st49{fill:url(#SVGID_00000172408224279166605190000013126481947533876390_);}\r\n\t.st50{fill:url(#SVGID_00000022533222165742022360000006026745252406543243_);}\r\n\t.st51{fill:url(#SVGID_00000041988818028141913040000012134228223753355451_);}\r\n\t.st52{fill:url(#SVGID_00000148658804576202318800000006704072733572587172_);}\r\n\t.st53{fill:url(#SVGID_00000011737004327554770480000018304185134224215950_);}\r\n\t.st54{fill:url(#SVGID_00000013911274408936925710000001725363180925447346_);}\r\n\t.st55{fill:url(#SVGID_00000182514284523102691820000006483625888299419069_);}\r\n\t.st56{fill:url(#SVGID_00000068638357645314563670000006107790523108482944_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "uuid-7ae8c3e2-70e6-4018-a567-1c111f03b87c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.7,
    y1: 8.725,
    x2: 16.12,
    y2: 8.725,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,55.2c-0.1-0.3-0.1-0.7-0.2-1.1c-0.5-0.1-0.9-0.2-1.3-0.2c-0.4-0.1-0.8-0.1-1.1-0.2s-0.8-0.1-1.3-0.2 c0.1,0.4,0.2,0.8,0.3,1.1c0.1,0.2,0.1,0.4,0.1,0.5c0.8,0.6,1.7,1.2,2.6,1.8c0,0,0.1,0,0.1,0c0.4,0.1,0.8,0.1,1.3,0.2 c-0.1-0.4-0.2-0.7-0.2-1S15.7,55.5,15.6,55.2L15.6,55.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177484060912730321880000009222548861405397907_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.48,
    y1: 15.65,
    x2: 49.92,
    y2: 15.65,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177484060912730321880000009222548861405397907_)"
    },
    d: "M47.4,46.5c-0.4,0-0.9,0.1-1.4,0.2 c-0.1,0.6-0.1,1-0.2,1.4c0,0.4-0.1,0.8-0.2,1.2c0,0.4-0.1,0.8-0.2,1.3c0.5-0.1,1-0.2,1.4-0.2c0.4-0.1,0.8-0.1,1.2-0.2 s0.8-0.1,1.3-0.2c0.1-0.5,0.2-0.9,0.2-1.3c0.1-0.4,0.1-0.8,0.2-1.2c0.1-0.4,0.1-0.8,0.2-1.4c-0.5,0.1-0.9,0.1-1.3,0.2 C48.2,46.3,47.8,46.4,47.4,46.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029017894238476188560000013211815888186249895_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.36,
    y1: 24.12,
    x2: 50.48,
    y2: 24.12,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029017894238476188560000013211815888186249895_)"
    },
    d: "M48,37.6c-0.4,0-0.9,0-1.4,0.1 c0,0.5,0,0.9,0,1.3c0,0.4,0,0.7,0,1.1c0,0.3,0,0.7,0,1.1s0,0.8-0.1,1.2c0.6,0,1-0.1,1.4-0.1c0.4,0,0.8-0.1,1.2-0.1 c0.4,0,0.8-0.1,1.3-0.1c0-0.4,0-0.8,0-1.2c0-0.4,0-0.7,0-1c0-0.3,0-0.7,0-1s0-0.8,0-1.2c-0.5,0-0.9,0.1-1.3,0.1S48.4,37.6,48,37.6 L48,37.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037693475395128812240000015887879897257366200_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.98,
    y1: 16.99,
    x2: 7.59,
    y2: 16.99,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037693475395128812240000015887879897257366200_)"
    },
    d: "M7.2,46.8C7.1,46.4,7,46,6.9,45.5 c-0.4-0.1-0.8-0.2-1.1-0.2c-0.3-0.1-0.6-0.1-0.9-0.2s-0.6-0.2-1-0.3c0.1,0.5,0.1,0.9,0.2,1.3c0,0,0,0,0,0.1 C4.7,47.1,5.3,48,6,48.9c0.2,0,0.3,0.1,0.5,0.1c0.3,0.1,0.7,0.2,1.1,0.3c-0.1-0.5-0.2-0.9-0.2-1.3S7.2,47.2,7.2,46.8L7.2,46.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101074541423494226540000011336264346644844200_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.117587e-8,
    y1: 33.425,
    x2: 1.39,
    y2: 33.425,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101074541423494226540000011336264346644844200_)"
    },
    d: "M1.4,32.5c0-0.5,0-1,0-1.4V30 c0-0.4,0-0.8,0-1.4c-0.4,0-0.6,0.1-0.8,0.1c-0.2,0-0.4,0-0.5,0.1C0,29.4,0,30,0,30.6s0,1.2,0.1,1.8c0.2,0,0.3,0,0.5,0.1 C0.8,32.5,1,32.5,1.4,32.5L1.4,32.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154406941105263590780000007486997986061150371_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5,
    y1: 40.87,
    x2: 1.44,
    y2: 40.87,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154406941105263590780000007486997986061150371_)"
    },
    d: "M0.6,25c0.2-0.1,0.4-0.1,0.8-0.2 c0-0.5,0-1,0-1.4c0-0.4,0-0.8,0-1.2c0-0.3,0-0.6,0-1C1,22.5,0.7,23.7,0.6,25C0.5,25,0.5,25,0.6,25L0.6,25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047039658217994107960000012231078846001565620_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.51,
    y1: 33.415,
    x2: 42.31,
    y2: 33.415,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047039658217994107960000012231078846001565620_)"
    },
    d: "M42.3,28.1c-0.5,0-0.9,0-1.3,0 c-0.4,0-0.7,0-1.1,0c-0.4,0-0.7,0-1.1,0c-0.4,0-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3v2.3c0,0.4,0,0.8,0,1.3c0.5,0,0.9,0,1.3,0 c0.4,0,0.8,0,1.1,0c0.4,0,0.7,0,1.1,0c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.3v-2.3C42.3,29.1,42.3,28.6,42.3,28.1L42.3,28.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070099062465256814730000010590717455118995366_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.49,
    y1: 25.955,
    x2: 1.44,
    y2: 25.955,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070099062465256814730000010590717455118995366_)"
    },
    d: "M1.4,37.8c0-0.4,0-0.8,0-1.4 c-0.4-0.1-0.6-0.2-0.8-0.2c0,0-0.1,0-0.1,0C0.7,37.4,1,38.7,1.4,40c0-0.4,0-0.7,0-1C1.4,38.5,1.4,38.2,1.4,37.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182518094771461261270000013177352654335082149_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.18,
    y1: 8.75,
    x2: 48.6,
    y2: 8.75,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182518094771461261270000013177352654335082149_)"
    },
    d: "M46.2,53.9c-0.4,0.1-0.8,0.1-1.3,0.2 c-0.1,0.4-0.2,0.8-0.2,1.1c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.2,0.6-0.2,1c0.5-0.1,0.9-0.1,1.3-0.2c0.1,0,0.2,0,0.2,0 c0.3,0,0.6-0.1,0.9-0.1c0.4-0.1,0.8-0.1,1.2-0.2c0.1-0.4,0.2-0.7,0.3-1c0-0.1,0-0.2,0.1-0.3c0-0.2,0.1-0.4,0.2-0.6 c0.1-0.3,0.2-0.7,0.3-1.1c-0.5,0.1-0.9,0.2-1.3,0.2C46.9,53.7,46.6,53.8,46.2,53.9L46.2,53.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031901694946780234870000011057129228219680155_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.71,
    y1: 16.96,
    x2: 56.31,
    y2: 16.96,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031901694946780234870000011057129228219680155_)"
    },
    d: "M54.5,45.3c-0.3,0.1-0.7,0.2-1.1,0.2 c-0.1,0.5-0.2,0.9-0.2,1.3c-0.1,0.4-0.1,0.8-0.2,1.2c-0.1,0.4-0.1,0.8-0.2,1.3c0.4-0.1,0.8-0.2,1.1-0.3c0.2-0.1,0.4-0.1,0.6-0.2 c0.6-0.8,1.1-1.6,1.6-2.5c0-0.1,0-0.2,0-0.3c0.1-0.4,0.1-0.8,0.2-1.3c-0.4,0.1-0.7,0.2-1,0.3C55.1,45.1,54.8,45.2,54.5,45.3 L54.5,45.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163046288649136214740000006291766722219750798_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.83,
    y1: 3.785,
    x2: 24.67,
    y2: 3.785,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163046288649136214740000006291766722219750798_)"
    },
    d: "M24.4,59.8c-0.5,0-1,0-1.3,0 c-0.4,0-0.8,0-1.2,0c-0.3,0-0.7,0-1.1,0c1.2,0.4,2.5,0.7,3.8,1c0,0,0-0.1,0-0.1C24.6,60.4,24.5,60.2,24.4,59.8L24.4,59.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154388995909436581000000017389099542494023349_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.35,
    y1: 42.765,
    x2: 50.48,
    y2: 42.765,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154388995909436581000000017389099542494023349_)"
    },
    d: "M47.8,18.9c-0.4,0-0.9-0.1-1.4-0.1 c0,0.5,0,0.9,0.1,1.2c0,0.4,0,0.7,0,1.1c0,0.4,0,0.7,0,1.1s0,0.8,0,1.3c0.5,0,1,0.1,1.4,0.1c0.4,0,0.8,0,1.2,0.1 c0.4,0,0.8,0.1,1.3,0.1c0-0.5,0-0.9,0-1.2c0-0.4,0-0.7,0-1s0-0.7,0-1c0-0.4,0-0.8,0-1.2c-0.5-0.1-0.9-0.1-1.3-0.1 C48.6,19,48.2,19,47.8,18.9L47.8,18.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086666538486021061480000000171597556633055413_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.22,
    y1: 3.505,
    x2: 32.08,
    y2: 3.505,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086666538486021061480000000171597556633055413_)"
    },
    d: "M29.6,59.8c-0.4,0-0.8,0-1.3,0 c0,0.4,0.1,0.6,0.1,0.8c0,0.2,0,0.4,0.1,0.5c0.6,0,1.2,0.1,1.8,0.1c0.6,0,1.1,0,1.7,0c0-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.5,0.1-0.8 c-0.5,0-0.9,0-1.3,0L29.6,59.8L29.6,59.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121261130380957104350000015919012571449562545_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.61,
    y1: 3.795,
    x2: 39.56,
    y2: 3.795,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121261130380957104350000015919012571449562545_)"
    },
    d: "M37.2,59.7c-0.4,0-0.8,0-1.3,0 c-0.1,0.4-0.2,0.6-0.2,0.9c0,0,0,0.1,0,0.1c1.3-0.2,2.7-0.6,4-1c-0.4,0-0.8,0-1.2,0C38,59.7,37.6,59.7,37.2,59.7L37.2,59.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101803290605220788300000011901842266222082731_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.46,
    y1: 51.21,
    x2: 49.89,
    y2: 51.21,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101803290605220788300000011901842266222082731_)"
    },
    d: "M46.8,10.8c-0.4-0.1-0.8-0.1-1.4-0.2 c0.1,0.5,0.1,0.9,0.2,1.3c0.1,0.4,0.1,0.8,0.2,1.2c0,0.4,0.1,0.9,0.2,1.4c0.5,0.1,1,0.1,1.4,0.2s0.8,0.1,1.2,0.2 c0.4,0.1,0.8,0.1,1.3,0.2c-0.1-0.5-0.1-1-0.2-1.4c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.1-0.8-0.2-1.3c-0.5-0.1-0.9-0.2-1.3-0.2 S47.2,10.8,46.8,10.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124149502131375940000000011985783040698324633_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.16,
    y1: 58.095,
    x2: 48.57,
    y2: 58.095,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124149502131375940000000011985783040698324633_)"
    },
    d: "M44.6,6c0.1,0.3,0.2,0.7,0.2,1.1 c0.5,0.1,0.9,0.2,1.3,0.2c0.4,0.1,0.8,0.1,1.1,0.2c0.4,0.1,0.8,0.2,1.3,0.2c-0.1-0.4-0.2-0.8-0.3-1.1c0-0.2-0.1-0.4-0.2-0.6 c-0.8-0.6-1.6-1.2-2.5-1.7c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.8-0.1-1.3-0.2c0.1,0.4,0.2,0.7,0.2,1C44.5,5.3,44.6,5.6,44.6,6L44.6,6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109710067031705533220000001056783303075985855_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.68,
    y1: 49.855,
    x2: 56.29,
    y2: 49.855,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109710067031705533220000001056783303075985855_)"
    },
    d: "M53.1,14.3c0.1,0.4,0.1,0.8,0.2,1.3 c0.4,0.1,0.8,0.2,1.1,0.2c0.3,0.1,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.2,1,0.3c-0.1-0.5-0.1-0.9-0.2-1.3c0-0.1,0-0.2,0-0.2 c-0.5-0.9-1.1-1.7-1.7-2.5c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.7-0.2-1.1-0.3c0.1,0.5,0.2,0.9,0.2,1.3S53,13.9,53.1,14.3 L53.1,14.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147920065174504486020000010073626274556531624_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.93,
    y1: 63.27,
    x2: 32.46,
    y2: 63.27,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147920065174504486020000010073626274556531624_)"
    },
    d: "M28.3,0.6c0,0.2,0,0.4-0.1,0.8 c0.5,0,0.9,0,1.3,0h1.2c0.4,0,0.8,0,1.3,0C32,1.1,32,0.9,32,0.7s0-0.4-0.1-0.6h0.6C31.7,0,31,0,30.2,0s-1.5,0-2.3,0.1h0.5 C28.4,0.3,28.3,0.5,28.3,0.6L28.3,0.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108292465508545568700000002264525087840084385_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.58,
    y1: 63.005,
    x2: 39.59,
    y2: 63.005,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108292465508545568700000002264525087840084385_)"
    },
    d: "M35.9,1.5c0.5,0,0.9,0,1.3,0 c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.2,0c-1.3-0.4-2.6-0.8-4-1c0,0.1,0,0.1,0.1,0.2C35.7,0.9,35.8,1.1,35.9,1.5L35.9,1.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118360915698936370910000009388629501586226833_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.85,
    y1: 40.985,
    x2: 59.89,
    y2: 40.985,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118360915698936370910000009388629501586226833_)"
    },
    d: "M58.9,23.4c0,0.4,0,0.8,0,1.4 c0.4,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c-0.2-1.4-0.6-2.8-1-4.1c0,0.5,0,0.9,0,1.3C58.9,22.6,58.9,23,58.9,23.4L58.9,23.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085242910713527671980000003189211161802732937_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.91,
    y1: 33.39,
    x2: 60.39,
    y2: 33.39,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085242910713527671980000003189211161802732937_)"
    },
    d: "M60.4,30.6c0-0.8,0-1.6-0.1-2.4v0.6 c-0.2,0-0.4-0.1-0.6-0.1s-0.4,0-0.8-0.1c0,0.5,0,1,0,1.4s0,0.8,0,1.2v1.4c0.4,0,0.6,0,0.8-0.1c0.2,0,0.4,0,0.6-0.1V33 C60.4,32.2,60.4,31.4,60.4,30.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144303816280675353320000001937952603497204628_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.01,
    y1: 49.88,
    x2: 7.62,
    y2: 49.88,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144303816280675353320000001937952603497204628_)"
    },
    d: "M6,12.3c-0.7,0.9-1.2,1.8-1.8,2.7 c0,0,0,0,0,0c-0.1,0.4-0.1,0.8-0.2,1.3c0.4-0.1,0.7-0.2,1-0.3C5.3,16,5.6,16,5.9,15.9c0.3-0.1,0.7-0.1,1.1-0.2 c0.1-0.5,0.2-0.9,0.2-1.3c0.1-0.4,0.1-0.8,0.2-1.1c0.1-0.4,0.1-0.8,0.2-1.3c-0.4,0.1-0.8,0.2-1.1,0.3C6.3,12.2,6.2,12.2,6,12.3 L6,12.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079478317728802383970000015259452092855233966_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.78,
    y1: 24.855,
    x2: 56.76,
    y2: 24.855,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079478317728802383970000015259452092855233966_)"
    },
    d: "M55,37c-0.3,0-0.6,0.1-1.1,0.1 c0,0.4,0,0.8,0,1.2c0,0.4,0,0.7,0,1c0,0.3,0,0.7,0,1s0,0.7,0,1.2c0.4-0.1,0.8-0.1,1.1-0.2s0.6-0.1,0.9-0.2 c0.3-0.1,0.6-0.1,0.9-0.2c0-0.4,0-0.8,0-1.1c0-0.3,0-0.6,0-1c0-0.3,0-0.6,0-1s0-0.7,0-1.1c-0.3,0-0.6,0.1-0.9,0.1S55.3,37,55,37 L55,37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158030001984318618830000012184749284849970059_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.95,
    y1: 33.44,
    x2: 56.8,
    y2: 33.44,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158030001984318618830000012184749284849970059_)"
    },
    d: "M56.8,28.5c-0.3,0-0.6,0-0.9,0 c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-1.1,0c0,0.4,0,0.8,0,1.2s0,0.7,0,1s0,0.7,0,1s0,0.8,0,1.2c0.4,0,0.8,0,1.1,0c0.3,0,0.6,0,0.9,0 c0.3,0,0.6,0,0.9,0c0-0.4,0-0.8,0-1.1s0-0.6,0-1s0-0.6,0-1S56.8,28.9,56.8,28.5L56.8,28.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006679227652020775940000010291951034820476325_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.78,
    y1: 42.01,
    x2: 56.76,
    y2: 42.01,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006679227652020775940000010291951034820476325_)"
    },
    d: "M54.9,19.8c-0.3-0.1-0.7-0.1-1.1-0.2 c0,0.4,0,0.8,0,1.1c0,0.4,0,0.7,0,1c0,0.3,0,0.6,0,1c0,0.4,0,0.7,0,1.2c0.4,0,0.8,0.1,1.1,0.1c0.3,0,0.6,0.1,0.9,0.1 c0.3,0,0.6,0.1,0.9,0.1c0-0.4,0-0.8,0-1.1c0-0.3,0-0.6,0-1c0-0.3,0-0.6,0-1c0-0.3,0-0.7,0-1.1c-0.3-0.1-0.6-0.1-0.9-0.2 C55.4,19.9,55.2,19.9,54.9,19.8L54.9,19.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000190705539969210700000010361312094657089154_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8,
    y1: 62.985,
    x2: 24.71,
    y2: 62.985,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000190705539969210700000010361312094657089154_)"
    },
    d: "M21.9,1.5c0.4,0,0.8,0,1.2,0 c0.4,0,0.8,0,1.3,0c0.1-0.4,0.2-0.6,0.2-0.8c0-0.1,0-0.1,0.1-0.2c-1.3,0.2-2.6,0.6-3.9,1C21.2,1.5,21.6,1.5,21.9,1.5L21.9,1.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004528729261453504680000011998810602450415496_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.73,
    y1: 58.095,
    x2: 16.14,
    y2: 58.095,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004528729261453504680000011998810602450415496_)"
    },
    d: "M14.8,4.3c-0.9,0.6-1.8,1.2-2.6,1.8 c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.3-0.2,0.7-0.3,1.1c0.5-0.1,0.9-0.2,1.3-0.2c0.4-0.1,0.7-0.1,1.1-0.2c0.4-0.1,0.8-0.1,1.3-0.2 c0.1-0.4,0.2-0.8,0.2-1.1s0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.2-1c-0.5,0.1-0.9,0.1-1.3,0.2C14.8,4.3,14.8,4.3,14.8,4.3L14.8,4.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014598830109298202900000000225442941330790305_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.62,
    y1: 33.44,
    x2: 50.56,
    y2: 33.44,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014598830109298202900000000225442941330790305_)"
    },
    d: "M50.5,28.2c-0.5,0-0.9,0-1.3,0 c-0.4,0-0.8,0-1.2,0c-0.4,0-0.9,0-1.4,0c0,0.5,0,0.9,0,1.3s0,0.8,0,1.1s0,0.7,0,1.1c0,0.4,0,0.8,0,1.3c0.5,0,1,0,1.4,0 c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.2v-1.1c0-0.4,0-0.7,0-1.1C50.5,29.1,50.5,28.7,50.5,28.2L50.5,28.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039856195282793350440000010558390093095284644_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.35,
    y1: 23.675,
    x2: 42.21,
    y2: 23.675,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039856195282793350440000010558390093095284644_)"
    },
    d: "M39.9,37.9c-0.4,0-0.7,0-1.1,0 s-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3s0,0.8,0,1.1s0,0.7,0,1.1c0,0.4,0,0.8,0,1.3c0.5,0,0.9,0,1.3,0c0.4,0,0.7,0,1.1,0 c0.3,0,0.7,0,1.1,0s0.8,0,1.2-0.1c0-0.5,0-0.9,0.1-1.2c0-0.4,0-0.7,0-1.1c0-0.4,0-0.7,0-1.1c0-0.4,0-0.8,0-1.3c-0.5,0-0.9,0-1.2,0 C40.6,37.9,40.2,37.9,39.9,37.9L39.9,37.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134220323362609190360000015837801325488107148_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.78,
    y1: 52.135,
    x2: 32.51,
    y2: 52.135,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134220323362609190360000015837801325488107148_)"
    },
    d: "M30.1,13.9c0.4,0,0.7,0,1.1,0 c0.4,0,0.8,0,1.3,0c0-0.6,0-1,0-1.4c0-0.4,0-0.8,0-1.2c0-0.4,0-0.8,0-1.3c-0.5,0-0.9,0-1.2,0c-0.4,0-0.7,0-1.1,0s-0.7,0-1.1,0 c-0.4,0-0.8,0-1.2,0c0,0.5,0,0.9,0,1.3c0,0.4,0,0.8,0,1.2c0,0.4,0,0.9,0,1.4c0.5,0,0.9,0,1.3,0C29.4,13.9,29.8,13.9,30.1,13.9 L30.1,13.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075141535854882911890000014661970715918823059_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.69,
    y1: 43.34,
    x2: 32.61,
    y2: 43.34,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075141535854882911890000014661970715918823059_)"
    },
    d: "M30.1,23.1h1.1c0.4,0,0.8,0,1.3,0 c0-0.5,0-0.9,0-1.3c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1c0-0.4,0-0.8,0-1.3c-0.5,0-0.9,0-1.3,0s-0.8,0-1.1,0s-0.7,0-1.1,0 c-0.4,0-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3s0,0.8,0,1.1c0,0.4,0,0.7,0,1.1s0,0.8,0,1.3c0.5,0,0.9,0,1.3,0S29.8,23.1,30.1,23.1 L30.1,23.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108996420784865610750000015794402474329531566_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.97,
    y1: 7.835,
    x2: 32.33,
    y2: 7.835,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108996420784865610750000015794402474329531566_)"
    },
    d: "M30.1,54.7c-0.3,0-0.7,0-1,0 c-0.4,0-0.7,0-1.2,0c0,0.4,0,0.8,0,1.1s0,0.6,0,0.9s0,0.6,0,0.9c0.4,0,0.8,0,1.1,0s0.6,0,1,0s0.6,0,1,0s0.7,0,1.1,0 c0-0.3,0-0.6,0-0.9c0-0.3,0-0.6,0-0.9c0-0.3,0-0.7,0-1.1c-0.4,0-0.8,0-1.2,0S30.5,54.7,30.1,54.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156562148571579687230000012912527594772233361_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.38,
    y1: 58.885,
    x2: 24.02,
    y2: 58.885,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156562148571579687230000012912527594772233361_)"
    },
    d: "M21.5,6.6c0.3,0,0.6,0,1,0 c0.4,0,0.7,0,1.2,0c0-0.4,0.1-0.8,0.1-1.1s0.1-0.6,0.1-0.9S24,3.9,24,3.6c-0.4,0-0.8,0-1.1,0c-0.3,0-0.6,0-1,0c-0.3,0-0.6,0-0.9,0 c-0.3,0-0.7,0-1.1,0c-0.1,0.3-0.1,0.7-0.2,0.9c-0.1,0.3-0.1,0.6-0.2,0.9s-0.1,0.7-0.2,1.1c0.4,0,0.8,0,1.1,0 C20.9,6.6,21.2,6.6,21.5,6.6L21.5,6.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023986103173908279840000000910613400005713550_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.37,
    y1: 7.945,
    x2: 24,
    y2: 7.945,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023986103173908279840000000910613400005713550_)"
    },
    d: "M22,57.5c0.3,0,0.6,0,1,0 c0.3,0,0.7,0,1.1,0c0-0.3-0.1-0.7-0.1-0.9c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.7-0.1-1.1c-0.4,0-0.8,0-1.2,0c-0.4,0-0.7,0-1,0 c-0.3,0-0.6,0-1,0c-0.3,0-0.7,0-1.1,0c0.1,0.4,0.1,0.8,0.2,1.1c0.1,0.3,0.1,0.6,0.2,0.9c0.1,0.3,0.1,0.6,0.2,1c0.4,0,0.8,0,1.1,0 S21.6,57.5,22,57.5L22,57.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048463226514735085420000016577258774236807558_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.97,
    y1: 58.975,
    x2: 32.32,
    y2: 58.975,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048463226514735085420000016577258774236807558_)"
    },
    d: "M32.2,3.6c-0.4,0-0.8,0-1.1,0 c-0.3,0-0.6,0-1,0s-0.6,0-1,0s-0.7,0-1.1,0c0,0.3,0,0.6,0,0.9c0,0.3,0,0.6,0,0.9s0,0.7,0,1.1c0.4,0,0.8,0,1.2,0s0.7,0,1,0 s0.6,0,1,0c0.4,0,0.7,0,1.2,0c0-0.4,0-0.8,0-1.1c0-0.3,0-0.6,0-0.9C32.3,4.2,32.2,3.9,32.2,3.6L32.2,3.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051363592543649563320000009696126381025489318_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.78,
    y1: 14.735,
    x2: 32.51,
    y2: 14.735,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051363592543649563320000009696126381025489318_)"
    },
    d: "M30.1,47.3c-0.4,0-0.7,0-1.1,0 c-0.4,0-0.8,0-1.3,0c0,0.6,0,1,0,1.4c0,0.4,0,0.8,0,1.2c0,0.4,0,0.8,0,1.3c0.5,0,0.9,0,1.2,0h2.1c0.4,0,0.8,0,1.2,0 c0-0.5,0-0.9,0-1.3c0-0.4,0-0.8,0-1.2c0-0.4,0-0.9,0-1.4c-0.5,0-0.9,0-1.3,0C30.9,47.3,30.5,47.3,30.1,47.3L30.1,47.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150782573893788976980000009590868146415157392_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.67,
    y1: 33.445,
    x2: 32.63,
    y2: 33.445,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150782573893788976980000009590868146415157392_)"
    },
    d: "M32.6,29.4c0-0.4,0-0.9,0-1.4 c-0.5,0-0.9,0-1.3,0s-0.8,0-1.1,0H29c-0.4,0-0.8,0-1.3,0c0,0.5,0,0.9,0,1.4v2.3c0,0.4,0,0.9,0,1.4c0.5,0,0.9,0,1.3,0h2.3 c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.4C32.6,31.7,32.6,29.4,32.6,29.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077317273330758417050000005339026075316883855_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.69,
    y1: 23.545,
    x2: 32.61,
    y2: 23.545,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077317273330758417050000005339026075316883855_)"
    },
    d: "M30.1,38c-0.4,0-0.7,0-1.1,0 s-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3s0,0.8,0,1.1c0,0.4,0,0.7,0,1.1s0,0.8,0,1.3c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.1,0s0.7,0,1.1,0 c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.3c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1s0-0.8,0-1.3c-0.5,0-0.9,0-1.3,0S30.5,38,30.1,38 L30.1,38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143579957890531788790000006307750336219661489_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3,
    y1: 7.935,
    x2: 40.93,
    y2: 7.935,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143579957890531788790000006307750336219661489_)"
    },
    d: "M38.8,54.6c-0.3,0-0.7,0-1,0 c-0.3,0-0.7,0-1.2,0c0,0.4-0.1,0.8-0.1,1.1c0,0.3-0.1,0.6-0.1,0.9c0,0.3-0.1,0.6-0.1,0.9c0.4,0,0.8,0,1.1,0c0.3,0,0.6,0,1,0 c0.3,0,0.6,0,0.9,0c0.3,0,0.7,0,1.1,0c0.1-0.3,0.1-0.7,0.2-1c0.1-0.3,0.1-0.6,0.2-0.9c0-0.3,0.1-0.7,0.2-1.1c-0.4,0-0.8,0-1.1,0 C39.4,54.6,39.1,54.6,38.8,54.6L38.8,54.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178182365224971522290000018284123935740367016_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.94,
    y1: 14.905,
    x2: 41.76,
    y2: 14.905,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178182365224971522290000018284123935740367016_)"
    },
    d: "M39.5,47.1c-0.3,0-0.7,0-1.1,0 c-0.4,0-0.8,0-1.2,0c0,0.6,0,1-0.1,1.4c0,0.4,0,0.8-0.1,1.2s-0.1,0.8-0.1,1.3c0.5,0,0.8,0,1.2,0s0.7,0,1,0c0.3,0,0.7,0,1,0 c0.4,0,0.7,0,1.2,0c0.1-0.5,0.1-1,0.1-1.4s0.1-0.8,0.1-1.2c0-0.4,0.1-0.9,0.1-1.5c-0.5,0-0.8,0-1.2,0.1S39.8,47.1,39.5,47.1 L39.5,47.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052100748241734192190000000659075822154746036_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.28,
    y1: 58.875,
    x2: 40.91,
    y2: 58.875,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052100748241734192190000000659075822154746036_)"
    },
    d: "M38.3,3.7c-0.3,0-0.6,0-1,0 c-0.3,0-0.7,0-1.1,0c0,0.3,0.1,0.6,0.1,0.9s0.1,0.6,0.1,0.9c0,0.3,0.1,0.7,0.1,1.1c0.4,0,0.8,0,1.2,0c0.3,0,0.7,0,1,0s0.6,0,1,0 c0.3,0,0.7,0,1.1,0c-0.1-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.1-0.6-0.2-0.9s-0.1-0.6-0.2-0.9c-0.4,0-0.8,0-1.1,0 C39,3.7,38.6,3.7,38.3,3.7L38.3,3.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070799486745488875140000001834546894731202217_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.53,
    y1: 14.92,
    x2: 23.36,
    y2: 14.92,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070799486745488875140000001834546894731202217_)"
    },
    d: "M21.1,51.1c0.3,0,0.7,0,1,0 c0.4,0,0.8,0,1.2,0c0-0.5-0.1-0.9-0.1-1.3c0-0.4,0-0.8-0.1-1.2c0-0.4,0-0.9-0.1-1.4c-0.5,0-0.9,0-1.2,0c-0.4,0-0.7,0-1.1,0 c-0.3,0-0.7,0-1.1,0c-0.4,0-0.8,0-1.2-0.1c0,0.6,0.1,1,0.1,1.5s0.1,0.8,0.1,1.2s0.1,0.8,0.1,1.4c0.4,0,0.8,0,1.2,0 C20.4,51.1,20.8,51.1,21.1,51.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121991583616180487140000010875981675445442696_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.35,
    y1: 43.21,
    x2: 42.21,
    y2: 43.21,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121991583616180487140000010875981675445442696_)"
    },
    d: "M39.7,18.4c-0.3,0-0.7,0-1.1,0 c-0.4,0-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3c0,0.4,0,0.8,0,1.1s0,0.7,0,1.1c0,0.4,0,0.8,0,1.3c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.1,0 c0.4,0,0.7,0,1.1,0s0.8,0,1.2,0c0-0.5,0-0.9,0-1.3c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1c0-0.4,0-0.8-0.1-1.2c-0.5,0-0.9,0-1.2-0.1 C40.4,18.4,40.1,18.4,39.7,18.4L39.7,18.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136402594450096171970000005545202634581369774_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.93,
    y1: 51.94,
    x2: 41.75,
    y2: 51.94,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136402594450096171970000005545202634581369774_)"
    },
    d: "M39.2,10c-0.3,0-0.7,0-1,0 c-0.4,0-0.8,0-1.2,0c0,0.5,0.1,0.9,0.1,1.3s0,0.8,0.1,1.2c0,0.4,0,0.9,0.1,1.4c0.5,0,0.9,0,1.2,0s0.7,0,1.1,0c0.3,0,0.7,0,1,0.1 s0.8,0,1.2,0.1c0-0.6-0.1-1-0.1-1.4c0-0.4-0.1-0.8-0.1-1.2c0-0.4-0.1-0.8-0.1-1.4c-0.4,0-0.8,0-1.2-0.1 C39.8,10.1,39.5,10.1,39.2,10L39.2,10z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046319418106815223030000002187212483509832378_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.5,
    y1: 33.44,
    x2: 6.35,
    y2: 33.44,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046319418106815223030000002187212483509832378_)"
    },
    d: "M5.3,32.7c0.3,0,0.6,0,1.1,0 c0-0.4,0-0.8,0-1.2s0-0.7,0-1s0-0.7,0-1s0-0.8,0-1.2c-0.4,0-0.8,0-1.1,0c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0c0,0.4,0,0.8,0,1.1 v1.9c0,0.3,0,0.7,0,1.1c0.3,0,0.6,0,0.9,0C4.7,32.7,4.9,32.7,5.3,32.7L5.3,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053513158795154380980000014336697707181876112_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.54,
    y1: 42.01,
    x2: 6.51,
    y2: 42.01,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053513158795154380980000014336697707181876112_)"
    },
    d: "M5.3,24.1C5.6,24.1,6,24,6.4,24 c0-0.4,0-0.8,0-1.2c0-0.4,0-0.7,0-1c0-0.3,0-0.6,0-1s0-0.7,0-1.1c-0.4,0.1-0.8,0.1-1.1,0.2c-0.3,0.1-0.6,0.1-0.9,0.2 S4,20.1,3.6,20.2c0,0.4,0,0.8,0,1.1s0,0.6,0,1c0,0.3,0,0.6,0,1c0,0.3,0,0.7,0,1.1c0.3,0,0.6-0.1,0.9-0.1C4.8,24.2,5,24.1,5.3,24.1 L5.3,24.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182486687286838047730000015533432277239365293_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.82,
    y1: 42.765,
    x2: 13.94,
    y2: 42.765,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182486687286838047730000015533432277239365293_)"
    },
    d: "M12.3,23.5c0.4,0,0.9,0,1.4-0.1 c0-0.5,0-0.9,0-1.3c0-0.4,0-0.7,0-1.1s0-0.7,0-1.1c0-0.4,0-0.8,0.1-1.2c-0.6,0-1,0.1-1.4,0.1S11.7,19,11.3,19s-0.8,0.1-1.3,0.1 c0,0.4,0,0.8-0.1,1.2c0,0.4,0,0.7,0,1s0,0.7,0,1c0,0.4,0,0.8,0,1.2c0.5,0,0.9-0.1,1.3-0.1C11.6,23.6,11.9,23.5,12.3,23.5 L12.3,23.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137118778549896309170000011490100464134258087_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.73,
    y1: 33.45,
    x2: 13.67,
    y2: 33.45,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137118778549896309170000011490100464134258087_)"
    },
    d: "M12.2,32.9c0.4,0,0.9,0,1.4,0 c0-0.5,0-0.9,0-1.3s0-0.8,0-1.1s0-0.7,0-1.1c0-0.4,0-0.8,0-1.3c-0.6,0-1,0-1.4,0c-0.4,0-0.8,0-1.2,0s-0.8,0-1.3,0 c0,0.5,0,0.9,0,1.2c0,0.4,0,0.7,0,1.1s0,0.7,0,1.1s0,0.8,0,1.2c0.5,0,0.9,0,1.3,0C11.4,32.9,11.8,32.9,12.2,32.9L12.2,32.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085213700715683579540000018211314591916605841_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.08,
    y1: 23.675,
    x2: 22.94,
    y2: 23.675,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085213700715683579540000018211314591916605841_)"
    },
    d: "M20.6,42.7c0.4,0,0.7,0,1.1,0 c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.3c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1c0-0.4,0-0.8,0-1.3c-0.5,0-0.9,0-1.3,0 c-0.4,0-0.8,0-1.1,0c-0.4,0-0.7,0-1.1,0c-0.4,0-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3s0,0.8,0,1.1c0,0.4,0,0.7,0,1.1c0,0.4,0,0.8,0.1,1.2 c0.5,0,0.9,0,1.2,0.1S20.2,42.7,20.6,42.7L20.6,42.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018207323294570137960000009595551791227413158_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.54,
    y1: 24.87,
    x2: 6.51,
    y2: 24.87,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018207323294570137960000009595551791227413158_)"
    },
    d: "M5.4,41.3c0.3,0.1,0.7,0.1,1.1,0.2 c0-0.4,0-0.8,0-1.2c0-0.3,0-0.7,0-1c0-0.3,0-0.7,0-1c0-0.3,0-0.7,0-1.2c-0.4,0-0.8-0.1-1.1-0.1C5,37,4.7,37,4.4,36.9 s-0.6-0.1-0.9-0.1c0,0.4,0,0.8,0,1.1c0,0.3,0,0.7,0,1c0,0.3,0,0.6,0,1c0,0.3,0,0.7,0,1.1c0.3,0.1,0.6,0.1,0.9,0.2 S5.1,41.2,5.4,41.3L5.4,41.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116940681017331269580000016754744974145833115_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.85,
    y1: 25.835,
    x2: 59.9,
    y2: 25.835,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116940681017331269580000016754744974145833115_)"
    },
    d: "M58.9,36.4c0,0.5,0,1,0,1.4s0,0.8,0,1.2 c0,0.4,0,0.8,0,1.3c0.5-1.3,0.8-2.7,1-4.2c-0.1,0-0.1,0-0.2,0.1C59.5,36.2,59.3,36.3,58.9,36.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057114662842153261120000007025069675115179944_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.81,
    y1: 24.13,
    x2: 13.94,
    y2: 24.13,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057114662842153261120000007025069675115179944_)"
    },
    d: "M12.5,42.2c0.4,0,0.9,0.1,1.4,0.1 c0-0.5,0-0.9-0.1-1.2s0-0.7,0-1.1s0-0.7,0-1.1s0-0.8,0-1.3c-0.6,0-1,0-1.4-0.1c-0.4,0-0.8,0-1.2-0.1c-0.4,0-0.8,0-1.3-0.1 c0,0.5,0,0.9,0,1.2c0,0.4,0,0.7,0,1c0,0.3,0,0.7,0,1c0,0.4,0,0.8,0.1,1.2c0.5,0,0.9,0.1,1.3,0.1C11.7,42.1,12.1,42.2,12.5,42.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121997313916992411930000014758056599530099101_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.55,
    y1: 51.95,
    x2: 23.37,
    y2: 51.95,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121997313916992411930000014758056599530099101_)"
    },
    d: "M20.8,14c0.3,0,0.7,0,1.1,0 c0.4,0,0.8,0,1.2,0c0-0.6,0-1,0.1-1.4c0-0.4,0-0.8,0.1-1.2c0-0.4,0.1-0.8,0.1-1.3c-0.5,0-0.8,0-1.2,0c-0.4,0-0.7,0-1,0 c-0.3,0-0.7,0-1,0c-0.4,0-0.7,0-1.2,0.1c-0.1,0.5-0.1,0.9-0.1,1.4c0,0.4-0.1,0.8-0.1,1.2c0,0.4-0.1,0.9-0.1,1.4 c0.5,0,0.8,0,1.2-0.1S20.5,14.1,20.8,14L20.8,14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125589485729985651950000018175907161268004529_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.09,
    y1: 43.21,
    x2: 22.95,
    y2: 43.21,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125589485729985651950000018175907161268004529_)"
    },
    d: "M20.4,23.2c0.4,0,0.7,0,1.1,0 c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.3s0-0.8,0-1.1c0-0.4,0-0.7,0-1.1c0-0.4,0-0.8,0-1.3c-0.5,0-0.9,0-1.3,0c-0.4,0-0.7,0-1.1,0 s-0.7,0-1.1,0c-0.4,0-0.8,0-1.2,0.1c0,0.5,0,0.9-0.1,1.2c0,0.4,0,0.7,0,1.1c0,0.4,0,0.7,0,1.1c0,0.4,0,0.8,0,1.3 c0.5,0,0.9,0,1.2,0S20.1,23.2,20.4,23.2L20.4,23.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017475049413811048650000013007725215542686357_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.98,
    y1: 33.465,
    x2: 22.78,
    y2: 33.465,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017475049413811048650000013007725215542686357_)"
    },
    d: "M20.4,33c0.4,0,0.7,0,1.1,0 c0.4,0,0.8,0,1.3,0c0-0.5,0-0.9,0-1.3v-2.3c0-0.4,0-0.8,0-1.3c-0.5,0-0.9,0-1.3,0c-0.4,0-0.8,0-1.1,0s-0.7,0-1.1,0 c-0.4,0-0.8,0-1.3,0c0,0.5,0,0.9,0,1.3s0,0.8,0,1.1c0,0.4,0,0.7,0,1.1c0,0.4,0,0.8,0,1.3c0.5,0,0.9,0,1.3,0C19.6,33,20,33,20.4,33 L20.4,33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168091840702622500690000009123060272055993276_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.38,
    y1: 15.65,
    x2: 14.81,
    y2: 15.65,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168091840702622500690000009123060272055993276_)"
    },
    d: "M13.4,50.4c0.4,0.1,0.8,0.1,1.4,0.2 c-0.1-0.5-0.1-0.9-0.2-1.3c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.1-0.9-0.2-1.4c-0.6-0.1-1-0.1-1.4-0.2s-0.8-0.1-1.2-0.2 c-0.4,0-0.8-0.1-1.3-0.2c0.1,0.5,0.1,1,0.2,1.4s0.1,0.8,0.2,1.2c0.1,0.4,0.1,0.8,0.2,1.3c0.5,0.1,0.9,0.2,1.3,0.2 S13.1,50.3,13.4,50.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175290862809259098980000010327628586124881792_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4,
    y1: 51.2,
    x2: 14.84,
    y2: 51.2,
    gradientTransform: "matrix(1 0 0 -1 0 64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A41E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175290862809259098980000010327628586124881792_)"
    },
    d: "M12.9,14.7c0.4-0.1,0.9-0.1,1.4-0.2 c0.1-0.6,0.1-1,0.2-1.4c0.1-0.4,0.1-0.8,0.2-1.2c0.1-0.4,0.1-0.8,0.2-1.3c-0.5,0.1-1,0.1-1.4,0.2c-0.4,0.1-0.8,0.1-1.2,0.2 c-0.4,0.1-0.8,0.1-1.3,0.2c-0.1,0.5-0.2,0.9-0.2,1.3s-0.1,0.8-0.2,1.2c-0.1,0.4-0.1,0.8-0.2,1.4c0.5-0.1,0.9-0.1,1.3-0.2 C12.1,14.8,12.5,14.7,12.9,14.7L12.9,14.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ae580bab76c4ab0c0f9c59e86bf8bb96.svg";
export { ForwardRef as ReactComponent };